import React from 'react';
import moment from 'moment-timezone';
import {
  OrderStatusBadge,
  PaymentStatusBadge,
  PlatformBadge,
} from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';
import { headerCls } from '../../../data/columns';

const orderTime = (order) => {
  const tz = order?.store?.timezoneid;
  return tz
    ? moment(order.createdate).tz(tz)
    : moment(order.createdate).utcOffset((order.timezone || 0) * 60);
};

export const buildCustomerOrderColumns = () => [
  {
    title: <span className={headerCls}>Receipt#</span>,
    key: 'receipt',
    render: (_, order) => (
      <div>
        <p className="text-sm font-bold text-slate-900 dark:text-slate-100">
          {order.ordernumberstr}
        </p>
        <p className="font-mono text-xs font-medium text-slate-500 dark:text-slate-400">
          #{order.orderid}
        </p>
      </div>
    ),
  },
  {
    title: <span className={headerCls}>Details</span>,
    key: 'details',
    render: (_, order) => (
      <div>
        <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
          {order.ordertype === 10 ? 'Dine-In' : 'To Go'}
        </p>
        <p className="text-xs font-medium text-slate-500 dark:text-slate-400">
          {order.store?.name}
        </p>
      </div>
    ),
  },
  {
    title: <span className={headerCls}>Payment Status</span>,
    key: 'payment',
    render: (_, order) => <PaymentStatusBadge status={order.paymentstatus} />,
  },
  {
    title: <span className={headerCls}>Time</span>,
    key: 'time',
    render: (_, order) => {
      const when = orderTime(order);
      return (
        <div>
          <p className="text-sm font-medium tabular-nums text-slate-900 dark:text-slate-100">
            {when.format('hh:mm A')}
          </p>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            {when.format('MMMM Do')}
          </p>
        </div>
      );
    },
  },
  {
    title: <span className={headerCls}>Order Type</span>,
    key: 'platform',
    render: (_, order) => <PlatformBadge status={order.platform} />,
  },
  {
    title: <span className={headerCls}>Total</span>,
    key: 'total',
    render: (_, order) => (
      <span className="text-sm font-bold tabular-nums text-slate-900 dark:text-slate-100">
        {formatCurrency(order.total - order.refund)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Order Status</span>,
    key: 'status',
    render: (_, order) => (
      <OrderStatusBadge
        status={order.orderstatus}
        label={
          order.orderstatus === 40 && order.refund !== order.total
            ? 'Partial Refund'
            : undefined
        }
      />
    ),
  },
];
